import i18next from 'i18next';

import uk from '../locales/uk.json';
import ru from '../locales/ru.json';

const LANGUAGE_STORAGE_KEY = 'site-language';

const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);

const initialLanguage = savedLanguage === 'ru' ? 'ru' : 'uk';

function applyTranslations() {
  const elements = document.querySelectorAll('[data-i18n]');

  elements.forEach(element => {
    const instructions = element.dataset.i18n.split(';');

    instructions.forEach(instruction => {
      const value = instruction.trim();

      if (!value) return;

      const attributeMatch = value.match(/^\[([^\]]+)\](.+)$/);

      if (attributeMatch) {
        const attributeName = attributeMatch[1];
        const translationKey = attributeMatch[2];

        element.setAttribute(
          attributeName,
          i18next.t(translationKey)
        );

        return;
      }

      element.innerHTML = i18next.t(value);
    });
  });

  document.documentElement.lang =
    i18next.resolvedLanguage === 'ru' ? 'ru' : 'uk';

  updateLanguageButtons();
}

function updateLanguageButtons() {
  const isUkrainian = i18next.resolvedLanguage === 'uk';
  const isRussian = i18next.resolvedLanguage === 'ru';

  document.querySelectorAll('.ua-btn').forEach(button => {
    button.classList.toggle('active', isUkrainian);
    button.setAttribute('aria-pressed', String(isUkrainian));
  });

  document.querySelectorAll('.ru-btn').forEach(button => {
    button.classList.toggle('active', isRussian);
    button.setAttribute('aria-pressed', String(isRussian));
  });
}

async function changeLanguage(language) {
  if (language !== 'uk' && language !== 'ru') return;

  await i18next.changeLanguage(language);

  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);

  applyTranslations();
}

function handleLanguageButtonClick(event) {
  if (!(event.target instanceof Element)) return;

  const languageButton = event.target.closest('.ua-btn, .ru-btn');

  if (!languageButton) return;

  const language = languageButton.classList.contains('ru-btn')
    ? 'ru'
    : 'uk';

  changeLanguage(language);
}

async function initializeI18n() {
  await i18next.init({
    lng: initialLanguage,
    fallbackLng: 'uk',

    supportedLngs: ['uk', 'ru'],

    resources: {
      uk: {
        translation: uk,
      },

      ru: {
        translation: ru,
      },
    },
  });

  applyTranslations();

  document.addEventListener(
    'click',
    handleLanguageButtonClick,
    true
  );
}

initializeI18n();

export { changeLanguage };